// require("aos/dist/aos.css");
// import AOS from 'aos';

$(function() {
    AOS.init({
        offset: 200, // offset (in px) from the original trigger point
        once: true, // whether animation should happen only once - while scrolling down
        //duration: 400, // values from 0 to 3000, with step 50ms
    });
});
